import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts, QueryParams } from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";

export class GuidanceService extends BaseRemoteService {
  public async get(params: QueryParams = {}, opts: Opts): Promise<string> {
    const url = `${this.apiRoot}/guidance${paramsToSearchString(params)}`;
    try {
      var data = await super.getRequest<Model>(url, opts);
      return data.markdown;
    } catch (e) {
      console.error("Failed to obtain guidance from guidance service");
      // This is a tolerable error so return an empty string
      return ""
    }
  }
}
